import React, { useState, useEffect } from "react";
import { validateFile } from "../utils/helper";
import { postMultipart } from "../utils/api";

const Upload = ({
  onFileSelect,
  labelText = "Upload",
  children,
  initialPreviewUrl = null,
  handleRemove,
  uploadEndpoint = null,
}) => {
  const [error, setError] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(initialPreviewUrl);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (initialPreviewUrl) setPreviewUrl(initialPreviewUrl);
  }, [initialPreviewUrl]);

  setTimeout(() => { if (error) setError(null); }, 2000);

  const handleFileChange = async (event) => {
    setError(null);
    const file = event.target.files?.[0];
    if (!file) return;
    const validationError = validateFile(file) || null;
    if (validationError) { setError(validationError); return; }

    if (uploadEndpoint) {
      setUploading(true);
      try {
        const fd = new FormData();
        fd.append("image", file);
        const data = await postMultipart(uploadEndpoint, fd);
        setPreviewUrl(data.url);
        onFileSelect(data.url);
      } catch {
        setError("Upload failed. Please try again.");
      } finally {
        setUploading(false);
      }
    } else {
      onFileSelect(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        if (file.type.startsWith("image/")) setPreviewUrl(reader.result);
        else if (file.type === "text/csv") setPreviewUrl("CSV file uploaded");
        else setPreviewUrl("No preview available");
      };
      if (file.type.startsWith("image/")) reader.readAsDataURL(file);
      else if (file.type === "text/csv") reader.readAsText(file);
    }
  };

  const handleRemoveFile = () => {
    setPreviewUrl(null);
    if (handleRemove) handleRemove();
  };

  return (
    <div className="flex flex-col items-start lg:items-center">
      <div className="border-2 border-dashed border-gray-300 py-8 md:py-2 px-6 md:px-8 lg:px-12 rounded-lg text-center cursor-pointer relative w-60 h-40 flex items-center justify-center">
        {uploading ? (
          <span className="text-sm text-gray-500">Uploading...</span>
        ) : previewUrl ? (
          <>
            {previewUrl.startsWith("data:image/") || previewUrl.startsWith("http") ? (
              <img src={previewUrl} alt="Preview" className="object-cover w-full h-full" />
            ) : (
              <div className="text-sm">{previewUrl}</div>
            )}
            <button
              onClick={handleRemoveFile}
              className="absolute top-0 right-0 mt-1 mr-1 bg-white rounded-full p-1 text-gray-500 hover:text-red-500 focus:outline-none"
            >
              &times;
            </button>
          </>
        ) : (
          <>
            <input
              type="file"
              accept="image/*,.csv"
              className="hidden"
              id="package-file-upload"
              onChange={handleFileChange}
            />
            <label htmlFor="package-file-upload" className="block">
              <span className="text-[#121212] border-2 border-[#121212] font-semibold text-[12px] sm:text-[16px] md:text-[12px] rounded-lg px-5 py-1">
                {labelText}
              </span>
            </label>
            {children}
          </>
        )}
      </div>
      {error && <p className="text-red-500 mt-2">{error}</p>}
    </div>
  );
};

export default Upload;
